import { useEffect, useRef, useState } from 'react';
import { proveritPriVhode, zamerPoKnopke } from './geolokaciyaVhoda';

/**
 * Замер местоположения при входе (`s704`, продолжение 05.10.2026) — фоновая часть
 * оболочки. Пока владелец замер не включил, компонент один раз спрашивает сервер,
 * получает «не спрашивать» и больше ничего не делает: ни запроса браузера, ни строки
 * на экране.
 *
 * ⛔ НЕ ЗАДЕРЖИВАЕТ РАБОЧЕЕ МЕСТО: ничего не ждёт и ничего не рисует, пока браузер
 * не оставил запрос без ответа. Тогда — одна строка с кнопкой: нажатие человека и
 * есть действие, которого браузер может требовать для запроса. Под «войти как»
 * компонент молчит: за экраном владелец, а не сотрудник.
 */
export function ZamerMestaPriVhode({ userId, podChuzhimVhodom }: { userId: number | null | undefined; podChuzhimVhodom: boolean }) {
  const [knopka, setKnopka] = useState(false);
  const [zanyat, setZanyat] = useState(false);
  const proveren = useRef<number | null>(null);

  useEffect(() => {
    if (!userId || podChuzhimVhodom || proveren.current === userId) return;
    proveren.current = userId;
    void proveritPriVhode().then((itog) => setKnopka(itog === 'button'));
  }, [userId, podChuzhimVhodom]);

  if (!knopka || podChuzhimVhodom) return null;

  const nazhal = async () => {
    setZanyat(true);
    try {
      setKnopka((await zamerPoKnopke()) === 'button');
    } finally {
      setZanyat(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3 border-b border-ops-border bg-ops-warning-soft px-4 py-2 text-sm text-ops-text" data-testid="zamer-mesta">
      <span>Проверка входа: браузер не получил ответ на запрос местоположения.</span>
      <button type="button" className="ops-link font-semibold" disabled={zanyat} onClick={() => void nazhal()} data-testid="zamer-mesta-knopka">
        {zanyat ? 'Определяю…' : 'Определить местоположение'}
      </button>
      <button type="button" className="ml-auto text-ops-text-tertiary hover:text-ops-text" aria-label="Скрыть" onClick={() => setKnopka(false)}>
        ✕
      </button>
    </div>
  );
}
